import { withRouter } from 'react-router-dom';

import requireAuthentication from '../../_hoc/requireAuthentication.jsx';
import AppRoute from './AppRoute.jsx';

export default withRouter(requireAuthentication()(AppRoute));
